/** 
 * Copyright © INOVUA TRADING.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sticky = exports.default = void 0;
var _getGlobal = require("../../getGlobal");
var globalObject = (0, _getGlobal.getGlobal)();
var div = globalObject.document && globalObject.document.createElement ? globalObject.document.createElement('div') : null;
var HAS_STICKY = false;
var sticky;
exports.sticky = sticky;
if (div) {
  div.style.position = 'sticky';
  if (div.style.position === 'sticky') {
    exports.sticky = sticky = 'sticky';
    HAS_STICKY = true;
  }
  if (!HAS_STICKY) {
    div.style.position = '-webkit-sticky';
    if (div.style.position === '-webkit-sticky') {
      HAS_STICKY = true;
      exports.sticky = sticky = '-webkit-sticky';
    }
  }
}
var _default = function _default() {
  return HAS_STICKY;
};
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./~/@inovua/reactdatagrid-community/packages/hasSticky/index.js
// module id = 156
// module chunks = 0